import { afterNextRender, Injectable, signal } from '@angular/core'

/**
 * وضعیت «هیدریشن کامل شد».
 *
 * روی سرور و در اولین رندر کلاینت همیشه `false` است و فقط بعد از پایان hydration
 * `true` می‌شود. بخش‌هایی که به وضعیت احراز هویت وابسته‌اند (وضعیتی که روی سرور
 * وجود ندارد و همیشه «مهمان» است) باید با این سیگنال گیت شوند تا HTML سرور با
 * اولین رندر کلاینت دقیقاً یکسان بماند.
 *
 * بدون این گیت، برای کاربری که نشست Keycloak فعال دارد، کلاینت دکمه «خروج» و
 * سایدبار را انتظار دارد در حالی که سرور دکمه «ورود» را رندر کرده است؛ Angular
 * ناسازگاری hydration (NG0500) می‌دهد و آن زیرشاخه هیدریت نمی‌شود — نتیجه اینکه
 * دکمه‌های هدر (مثل «ورود») دیده می‌شوند اما هیچ listener ای ندارند و کلیک روی
 * آن‌ها هیچ کاری نمی‌کند.
 */
@Injectable({ providedIn: 'root' })
export class HydrationStateService {
	/** false تا پایان hydration؛ بعد از اولین رندر کلاینت true می‌شود. */
	readonly hydrated = signal(false)

	constructor() {
		// روی سرور اجرا نمی‌شود؛ روی کلاینت دقیقاً بعد از hydration اجرا می‌شود.
		afterNextRender(() => this.hydrated.set(true))
	}
}
